import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=11fe93e8&scoped=true&"
import script from "./AppContent.vue?vue&type=script&lang=ts&"
export * from "./AppContent.vue?vue&type=script&lang=ts&"
import style0 from "./AppContent.vue?vue&type=style&index=0&id=11fe93e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11fe93e8",
  null
  
)

/* custom blocks */
import block0 from "./AppContent.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports